import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import StudentsSelector from 'modules/students/components/StudentsSelector';

const useStyles = makeStyles((theme) => ({
  textField: {
    marginBottom: theme.spacing(3),
    maxWidth: 200,
  },
}));

const LessonForm = (props) => {
  const classes = useStyles();
  const { name, onChangeName, error, studentsSelectorProps } = props;

  const handleChangeName = useCallback(
    (event) => {
      onChangeName(event.target.value);
    },
    [onChangeName]
  );

  return (
    <Box display="flex" flexDirection="column" width="100%">
      <TextField
        className={classes.textField}
        value={name}
        onChange={handleChangeName}
        label={<FormattedMessage id="field.name.label" />}
        error={Boolean(error)}
      />
      <StudentsSelector {...studentsSelectorProps} />
    </Box>
  );
};

LessonForm.propTypes = {
  name: PropTypes.string,
  onChangeName: PropTypes.func.isRequired,

  error: PropTypes.string,
  studentsSelectorProps: PropTypes.object.isRequired,
};

LessonForm.defaultProps = {
  name: '',
  error: undefined,
};

export default LessonForm;
